/* mgs-commercial.js — MGS Commercial Quotes page
 * Chip multiselect, scroll reveal (with fallback), and quote-form submit.
 * Posts JSON to the webhook URL set on .mgsc[data-webhook]. No dependencies.
 */
(function () {
  'use strict';

  var root = document.querySelector('.mgsc');
  if (!root) return;
  root.classList.remove('nojs');

  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---- chips ---- */
  var chipBox = $('[data-chips]', root);
  if (chipBox) {
    chipBox.addEventListener('click', function (e) {
      var c = e.target.closest('.chip');
      if (c) c.classList.toggle('on');
    });
  }

  /* ---- scroll reveal (graceful if unsupported) ---- */
  var reveals = $all('.reveal', root);
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el, i) { el.style.transitionDelay = (i % 4 * 60) + 'ms'; io.observe(el); });
    // safety: anything still hidden after 1.6s gets revealed
    setTimeout(function () { reveals.forEach(function (el) { el.classList.add('in'); }); }, 1600);
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- form ---- */
  var form = $('[data-quote-form]', root);
  if (!form) return;
  var card = form.closest('.qcard') || form;
  var msg = $('[data-formmsg]', form);
  var btn = $('[data-submit]', form);
  var WEBHOOK = (root.getAttribute('data-webhook') || '').trim();
  var lastAt = 0;

  function val(name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? (el.value || '').trim() : '';
  }
  function setErr(name, on) {
    var el = form.querySelector('[name="' + name + '"]');
    if (el) el.classList[on ? 'add' : 'remove']('err');
  }
  function showMsg(text, ok) {
    if (!msg) return;
    msg.textContent = text;
    msg.className = 'formmsg ' + (ok ? 'ok' : 'bad');
  }
  function emailOk(v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v); }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    // honeypot: silently succeed for bots
    if (val('company_url')) { card.classList.add('sent'); showMsg('Thanks — your request is in. A specialist will reach out shortly.', true); return; }

    // dedupe rapid double-submits
    var now = Date.now();
    if (now - lastAt < 4000) return;

    var equipment = $all('.chip.on', form).map(function (c) { return c.getAttribute('data-value') || c.textContent.trim(); });
    var required = ['name', 'email', 'phone', 'zip'];
    var firstBad = null;
    required.forEach(function (n) {
      var bad = !val(n) || (n === 'email' && !emailOk(val(n)));
      setErr(n, bad);
      if (bad && !firstBad) firstBad = n;
    });
    if (!equipment.length) { showMsg('Please pick at least one type of equipment.', false); return; }
    if (firstBad) {
      showMsg('Please complete the highlighted fields with a valid email.', false);
      var be = form.querySelector('[name="' + firstBad + '"]'); if (be) be.focus();
      return;
    }

    var payload = {
      source: 'commercial-quote-page',
      submitted_at: new Date().toISOString(),
      equipment: equipment,
      bays_units: val('bays'),
      timeline: val('timeline'),
      business_type: val('business_type'),
      name: val('name'),
      business_name: val('business'),
      email: val('email'),
      phone: val('phone'),
      delivery_zip: val('zip'),
      notes: val('notes'),
      page_url: window.location.href
    };

    lastAt = now;
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Sending…'; }

    if (!WEBHOOK) {
      // No backend wired yet — confirm to the user, log payload for QA.
      console.warn('[mgs-commercial] No webhook configured; payload not sent:', payload);
      card.classList.add('sent');
      showMsg('Thanks, ' + payload.name.split(' ')[0] + '! Your request is in. A specialist will reach out shortly.', true);
      return;
    }

    fetch(WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('bad status ' + r.status);
      card.classList.add('sent');
      showMsg('Thanks, ' + payload.name.split(' ')[0] + '! Your request is in. A specialist will reach out the same business day.', true);
    }).catch(function (err) {
      console.error('[mgs-commercial] submit failed', err);
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Request my quote'; }
      showMsg('Something went wrong sending that. Please call 307-381-1810 and we’ll take it down right away.', false);
    });
  });
})();
